<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/G3r9hc/tc-custom/9781453276884.jpg?1718283488753" alt="This image is the cover for the book Sugar Baby Sampler"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Sugar Baby Sampler
      </h1>
      <p class="bookDescription body article font2">
        <b>A selection of <i>Sugar Baby</i> recipes to get you started</b><br/>Cookbooks with recipes for baking with sugar (in the oven) continue to top the bestseller lists. But until now, no one has set out to do a cookbook with recipes on cooking with sugar (on the stovetop). The <i>Sugar Baby Sampler</i> gives a taste of the full <i>Sugar Baby </i>cookbook, including three of Gesine Bullock-Prado’s recipes for candy, confections, and treats. With the simplest instructions and the author’s hilarious voice, the <i>Sugar Baby Sampler</i> offers a delicious selection of the one hundred recipes found in <i>Sugar Baby</i>, which will satisfy even the most demanding sweet tooth.
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Tina Rupp, Gesine Bullock-Prado
      </h2>
      
      <p class="authorDescription body article">Gesine Bullock-Prado is the founder of the Gesine Confectionary product line and author of <i>My Life from Scratch</i>. She lives in Hartford, Vermont, with two dogs, seven chickens, ten Indian Runner ducks, six geese, two goats, and one wonderful husband. She cooks with her animals&rsquo; eggs and milk, as well as produce from her garden. She has been featured in <i>People</i> and many other national publications; she has also appeared on the Food Network, the <i>Rachael Ray Show</i>, and the <i>Today Show</i>. &#160;</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Abrams
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?29ad98d0